import { z } from 'zod';
import { getMutationSchema } from '../../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../../resource-base/artifactResourceTypes';

export enum VCycleElementDecoratorPropertyValidation {
    HORIZONTAL_PRIORITY = 'HORIZONTAL_PRIORITY',
    VERTICAL_PRIORITY = 'VERTICAL_PRIORITY',
    TEXT_COLOR = 'TEXT_COLOR',
    BACKGROUND_COLOR = 'BACKGROUND_COLOR',
}

export const VCycleElementDecoratorResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.V_CYCLE_ELEMENT_DECORATOR).default(ResourceType.V_CYCLE_ELEMENT_DECORATOR),
    horizontalPriority: z.number().nullable(),
    verticalPriority: z.number().nullable(),
    textColor: z.string().nullable(),
    backgroundColor: z.string().nullable(),
});
export const VCycleElementDecoratorMutationResourceSchema = getMutationSchema(VCycleElementDecoratorResourceSchema);

export type VCycleElementDecoratorResource = z.infer<typeof VCycleElementDecoratorResourceSchema>;

export const defaultVCycleElementDecoratorResource: VCycleElementDecoratorResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.V_CYCLE_ELEMENT_DECORATOR,
    horizontalPriority: null,
    verticalPriority: null,
    textColor: null,
    backgroundColor: null,
};

export function useVCycleElementDecoratorActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/v-cycle-element-decorator',
            ResourceType.V_CYCLE_ELEMENT_DECORATOR,
            VCycleElementDecoratorResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/v-cycle-element-decorator',
            ResourceType.V_CYCLE_ELEMENT_DECORATOR,
            VCycleElementDecoratorResourceSchema
        ),
    };
}
